import { CoreConstant } from '../constant/base.constant';
import { Language } from '../model/user/language.enum';

export class CommonUtil {
    public static showAppLoader() {
        const element = document.getElementById('vc-page-loader');
        element?.setAttribute('style', 'visibility: visible; opacity: 1');
    }

    /**
     * Hides the loader that covers the entire viewport.
     */
    public static hideAppLoader() {
        const element = document.getElementById('vc-page-loader');
        element?.setAttribute('style', 'visibility: hidden; opacity: 0');
    }

    static changeLanguage(lang: Language | null, reload = false): Language {
        if (!lang) {
            lang = Language.EN;
        }

        localStorage.setItem(CoreConstant.VC_LANGUAGE_ABBREVIATION, `${lang}`);
        if (reload) {
            window.location.reload();
        }
        return lang;
    }

    /**
     * Gets the computed color of a CSS variable based on current Theme being used
     */
    static getRenderedColor(color: string): string {
        return getComputedStyle(document.documentElement).getPropertyValue(color);
    }
}
